import type { FC } from "react";

import { CaseTimePane } from "../../timeTracking/case/CaseTimePane";
import { useCaseIde } from "../context/CaseIdeContext";

/** "Time" open in the center pane. */
export const TimePane: FC = () => {
  const { individualId } = useCaseIde();
  return <CaseTimePane individualId={individualId} />;
};
